var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 521.97 1080"
    },
    xmlSpace: "preserve",
    viewBox: "125.15 409.83 271.65 260.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000098184582445566745100000005521371396867198630_);fill:#F8C9DD;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 125.16,
    y: 409.83,
    width: 271.64,
    height: 260.35
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003103415400246709260000000040889397748007063_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000003103415400246709260000000040889397748007063_)",
      fill: "#F8C9DD"
    },
    d: "M390.7,527.85    c7.76-7.25,8.18-19.41,0.93-27.18c-3.08-3.3-7.22-5.41-11.7-5.96L319.88,486c-6.34-0.89-11.82-4.88-14.62-10.64l-26.85-54.41    c-4.48-9.63-15.92-13.8-25.55-9.32c-4.11,1.91-7.41,5.21-9.32,9.32l-26.85,54.41c-2.8,5.76-8.28,9.74-14.61,10.64l-60.05,8.72    c-10.54,1.3-18.03,10.9-16.73,21.44c0.55,4.48,2.66,8.62,5.96,11.7l43.45,42.49c4.6,4.44,6.69,10.88,5.57,17.18l-10.25,59.73    c-2.04,10.42,4.75,20.52,15.17,22.57c4.45,0.87,9.06,0.14,13.03-2.06l53.71-28.2c5.65-3.01,12.42-3.01,18.07,0l53.71,28.2    c9.28,5.15,20.98,1.8,26.14-7.48c2.2-3.97,2.93-8.58,2.05-13.03l-10.25-59.8c-1.09-6.28,0.99-12.68,5.57-17.11L390.7,527.85    L390.7,527.85z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPink);
export default __webpack_public_path__ + "static/media/Star_Pink.e14019b9b0e1b1dded05a9bab35c2298.svg";
export { ForwardRef as ReactComponent };